import { render, staticRenderFns } from "./CeppFooter.vue?vue&type=template&id=78a1358e&scoped=true&"
import script from "./CeppFooter.vue?vue&type=script&lang=js&"
export * from "./CeppFooter.vue?vue&type=script&lang=js&"
import style0 from "./CeppFooter.vue?vue&type=style&index=0&id=78a1358e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a1358e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
